<script>
  import { cn } from '@lib/utils'

  let { children, footer, align = 'end' } = $props()

</script>

<div class={cn("form-buttons", align === 'end' ? 'justify-end' : 'justify-start')}>
  <div class="flex flex-col gap-2">
    <div class="flex gap-2">{@render children?.()}</div>
    <div class="flex flex-col gap-2">
      {@render footer?.()}
    </div>
  </div>
</div>
